<template>
  <svg aria-hidden="true" viewBox="0 0 800 594.23" ...attributes>
    <path
      fill="#104C76"
      d="M580,434.23a20,20,0,0,1-20-20c0-88.22-71.78-160-160-160S240,326,240,414.23a20,20,0,0,1-40,0c0-110.28,89.72-200,200-200s200,89.72,200,200A20,20,0,0,1,580,434.23Z"
    ></path>
    <path
      fill="#104C76"
      d="M400,594.23a100.17,100.17,0,0,1-98-80H20a20,20,0,0,1,0-40H320a20,20,0,0,1,20,20,60,60,0,0,0,120,0,20,20,0,0,1,20-20H780a20,20,0,0,1,0,40H498A100.17,100.17,0,0,1,400,594.23Z"
    ></path>
    <path
      fill="#63CC98"
      d="M700.7,304.79a20,20,0,0,1-6.84-38.8l56.38-20.52a20,20,0,1,1,13.68,37.59l-56.38,20.52A20,20,0,0,1,700.7,304.79Z"
    ></path>
    <path
      fill="#63CC98"
      d="M645.14,208.54a20,20,0,0,1-12.86-35.32l46-38.57A20,20,0,1,1,704,165.29l-46,38.57A19.9,19.9,0,0,1,645.14,208.54Z"
    ></path>
    <path
      fill="#63CC98"
      d="M560,137.11a20,20,0,0,1-17.3-30l30-52a20,20,0,1,1,34.64,20l-30,52A20,20,0,0,1,560,137.11Z"
    ></path>
    <path
      fill="#63CC98"
      d="M455.59,99.1a20,20,0,0,1-19.72-23.48l10.42-59.09a20,20,0,1,1,39.39,7L475.26,82.57A20,20,0,0,1,455.59,99.1Z"
    ></path>
    <path
      fill="#63CC98"
      d="M344.41,99.1a20,20,0,0,1-19.67-16.53L314.32,23.48a20,20,0,0,1,39.39-6.95l10.42,59.09A20,20,0,0,1,344.41,99.1Z"
    ></path>
    <path
      fill="#63CC98"
      d="M240,137.11a20,20,0,0,1-17.34-10l-30-52a20,20,0,0,1,34.64-20l30,52a20,20,0,0,1-17.3,30Z"
    ></path>
    <path
      fill="#63CC98"
      d="M154.86,208.54A19.9,19.9,0,0,1,142,203.86l-46-38.57a20,20,0,1,1,25.71-30.64l46,38.57a20,20,0,0,1-12.86,35.32Z"
    ></path>
    <path
      fill="#63CC98"
      d="M99.3,304.79a20,20,0,0,1-6.84-1.21L36.08,283.06a20,20,0,1,1,13.68-37.59L106.14,266a20,20,0,0,1-6.84,38.8Z"
    ></path>
  </svg>
</template>
